import React, { useState } from "react";
import { fCurrency } from "../../../helper/formatNumber";
import { Avatar } from "antd";

const locale = require("react-redux-i18n").I18n;

const Profile = ({ username, name, value }) => {
  return (
    <div style={{ display: "flex", gap: "8px", marginBottom: "14px" }}>
      {/* <div style={{background: 'blue', borderRadius: '50%', overflow: 'hidden', width: '42px', height: '42px'}}></div> */}
      <Avatar
        style={{ backgroundColor: "#D2D2D2", color: "#fff", flex: "none" }}
        size={48}
      >
        <span style={{ fontSize: "24px", fontWeight: "700" }}>
          {/^[a-zA-Z]$/.test(username?.charAt(0)) ? username?.charAt(0) : "-"}
        </span>
      </Avatar>
      <div>
        <div style={{ fontWeight: "800" }}>{username}</div>
        <div style={{ color: "#A3A3A3", fontSize: "12px" }}>
          {fCurrency(value)}
        </div>
      </div>
    </div>
  );
};

const CardLuckyDraw = ({ data }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 23; // จำนวนรายการต่อหน้า
  const totalPages = Math.ceil((data?.rows?.length || 0) / itemsPerPage);

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  // คำนวณ index ของข้อมูลที่จะแสดง
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const currentItems = data?.rows?.slice(startIndex, endIndex);

  const commonButtonStyle = {
    border: "none",
    borderRadius: "4px",
    padding: "4px 12px",
    cursor: "pointer",
    backgroundColor: "transparent",
  };

  const activeButtonStyle = {
    ...commonButtonStyle,
    backgroundColor: "#E5E7EB",
    fontWeight: "bold",
  };

  const renderPaginationButtons = () => {
    let buttons = [];

    // Always show first page
    buttons.push(
      <button
        key={1}
        onClick={() => handlePageChange(1)}
        style={currentPage === 1 ? activeButtonStyle : commonButtonStyle}
      >
        1
      </button>
    );

    // Show dots before current page if current page is not 1 or 2
    if (currentPage > 2) {
      buttons.push(
        <span key="dots1" style={{ color: "#6B7280" }}>
          ...
        </span>
      );
    }

    // Show current page if it's not first or last
    if (currentPage !== 1 && currentPage !== totalPages) {
      buttons.push(
        <button
          key={currentPage}
          onClick={() => handlePageChange(currentPage)}
          style={activeButtonStyle}
        >
          {currentPage}
        </button>
      );
    }

    // Show dots after current page if current page is not last or second to last
    if (currentPage < totalPages - 1) {
      buttons.push(
        <span key="dots2" style={{ color: "#6B7280" }}>
          ...
        </span>
      );
    }

    // Always show last page if it's not the first page
    if (totalPages > 1) {
      buttons.push(
        <button
          key={totalPages}
          onClick={() => handlePageChange(totalPages)}
          style={
            currentPage === totalPages ? activeButtonStyle : commonButtonStyle
          }
        >
          {totalPages}
        </button>
      );
    }

    return buttons;
  };

  return (
    <div
      className="border d-flex flex-column"
      style={{
        borderRadius: "8px",
        gap: "16px",
        height: "480px",
        padding: "20px",
      }}
    >
      <div className="text-bold" style={{ fontSize: "16px" }}>
        {locale.t("contestAward.lucky_draw")}
      </div>
      {data?.length > 0 && (
        <div style={{ overflow: "auto" }}>
          {data?.map((item, index) => {
            return (
              <Profile
                key={item.id}
                username={item?.participant?.username || "-"}
                name={item?.reward?.name}
                value={item?.reward?.value}
              />
            );
          })}
        </div>
      )}
      {data?.length <= 0 && (
        <div
          style={{
            color: "#A3A3A3",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100%",
            flexDirection: "column",
          }}
        >
          <img
            src="/assets/images/icons/imageNotFound.png"
            style={{ width: "52px", height: "52px" }}
            alt="No lucky draw results found"
          />
          <div style={{ fontWeight: "800" }}>
            {locale.t("contestAward.title_not_found")}
          </div>
          <div style={{ fontSize: "12px" }}>
            {locale.t("contestAward.description_not_found")}
          </div>
        </div>
      )}
      {totalPages > 1 && (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            gap: "8px",
            alignItems: "center",
          }}
        >
          <button
            onClick={() => handlePageChange(currentPage - 1)}
            disabled={currentPage === 1}
            style={{
              border: "none",
              borderRadius: "4px",
              padding: "4px 12px",
              cursor: currentPage === 1 ? "default" : "pointer",
              opacity: currentPage === 1 ? 0.5 : 1,
              backgroundColor: "transparent",
            }}
          >
            &lt;
          </button>
          {renderPaginationButtons()}
          <button
            onClick={() => handlePageChange(currentPage + 1)}
            disabled={currentPage === totalPages}
            style={{
              border: "none",
              borderRadius: "4px",
              padding: "4px 12px",
              cursor: currentPage === totalPages ? "default" : "pointer",
              opacity: currentPage === totalPages ? 0.5 : 1,
              backgroundColor: "transparent",
            }}
          >
            &gt;
          </button>
        </div>
      )}
    </div>
  );
};

export default CardLuckyDraw;
